import { Divider } from "@/components/shared/divider";
// import { Link } from "@/components/shared/link";
import { View } from "@/components/ui";
// import { ArrowLeft } from "@/components/shared/icons";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Outlet } from "react-router-dom";
import { NavTabs } from "@/components/shared/nav-tabs";
import { invoiceTabs } from "@/containers/profile/invoices/lib";
import { usePathname } from "@/components/hooks/use-pathname";
import { AutoPayWidget } from "@/components/shared/invoices/auto-pay";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";

export function InvoicePage() {
  const pathname = usePathname();
  const { isMobile } = useWindowDimensions();
  const { push } = useRoute();
  return (
    <View>
      <View className="flex flex-row items-center gap-2 p-4 md:mb-4 md:p-0">
        {/* CONSISTENECY PROBLEM <Link href="/profile">
          <Link href="/profile">
            <ArrowLeft className="size-5" />
          </Link>
        )} */}
        <IconButton
          variant={isMobile ? "ghost" : "secondary"}
          color="foreground"
          iconName="arrowLeft"
          rounded="full"
          className="p-0 md:hidden md:px-3 md:py-2"
          onClick={() => push({ pageKey: "profile" })}
        />
        <Typography variant="label-md">Invoices</Typography>
      </View>
      <Divider />
      <View className="mb-4 mt-4 px-4 md:px-0">
        <AutoPayWidget />
      </View>
      <NavTabs items={invoiceTabs} active={pathname} />
      <Outlet />
    </View>
  );
}
